import React, { HTMLAttributes, ReactNode } from 'react'
import { Reference } from 'react-popper'

export interface DropdownTriggerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

export default function DropdownTrigger(props: DropdownTriggerProps): JSX.Element {
  const { children, ...otherProps } = props

  return (
    <Reference>
      {({ ref }) => (
        <div ref={ref} {...otherProps}>
          {children}
        </div>
      )}
    </Reference>
  )
}
